import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
/**
 * Merge Tailwind class names intelligently.
 * 1. clsx resolves conditional/array/object class inputs
 * 2. tailwind-merge resolves conflicting Tailwind utilities (last wins)
 * 3. exact-string dedupe for tidy output
 */
export function cn(...inputs) {
    const merged = twMerge(clsx(inputs));
    const classes = merged.split(" ").filter(Boolean);
    const unique = Array.from(new Set(classes));
    return unique.join(" ");
}
